// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.properties.RentalManagerUserPropertyEditAmenitiesV2WebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  UserPropertyEditHasAirConditioningUtilityIncludedV2RequestDto,
  UserPropertyEditHasAssistedLivingV2RequestDto,
  UserPropertyEditHasAttachedGarageParkingV2RequestDto,
  UserPropertyEditHasBarbecueV2RequestDto,
  UserPropertyEditHasBasketballSportCourtV2RequestDto,
  UserPropertyEditHasBicycleStorageV2RequestDto,
  UserPropertyEditHasBocceSportCourtV2RequestDto,
  UserPropertyEditHasBuildingWideWirelessV2RequestDto,
  UserPropertyEditHasBusinessCenterCommunityRoomV2RequestDto,
  UserPropertyEditHasCableTvUtilityIncludedV2RequestDto,
  UserPropertyEditHasCableTvV2RequestDto,
  UserPropertyEditHasCarpetFloorCoveringV2RequestDto,
  UserPropertyEditHasCeilingFanV2RequestDto,
  UserPropertyEditHasCentralAirConditioningV2RequestDto,
  UserPropertyEditHasCityViewV2RequestDto,
  UserPropertyEditHasClubHouseCommunityRoomV2RequestDto,
  UserPropertyEditHasConcreteFloorCoveringV2RequestDto,
  UserPropertyEditHasConferenceRoomCommunityRoomV2RequestDto,
  UserPropertyEditHasControlledAccessSecurityV2RequestDto,
  UserPropertyEditHasConvectionOvenApplianceV2RequestDto,
  UserPropertyEditHasCoveredParkingParkingV2RequestDto,
  UserPropertyEditHasDeckOutDoorCommonAreaV2RequestDto,
  UserPropertyEditHasDetachedGarageParkingV2RequestDto,
  UserPropertyEditHasDisabledAccessV2RequestDto,
  UserPropertyEditHasDishwasherApplianceV2RequestDto,
  UserPropertyEditHasDoormanSecurityV2RequestDto,
  UserPropertyEditHasDoubleOvenApplianceV2RequestDto,
  UserPropertyEditHasDryCleaningDropOffV2RequestDto,
  UserPropertyEditHasElectricHeatingSourceV2RequestDto,
  UserPropertyEditHasElectricityUtilityIncludedV2RequestDto,
  UserPropertyEditHasElevatorV2RequestDto,
  UserPropertyEditHasFireplaceV2RequestDto,
  UserPropertyEditHasFitnessCenterCommunityRoomV2RequestDto,
  UserPropertyEditHasFlexibleLeaseLengthsV2RequestDto,
  UserPropertyEditHasFreezerApplianceV2RequestDto,
  UserPropertyEditHasGameRoomCommunityRoomV2RequestDto,
  UserPropertyEditHasGarbageDisposalApplianceV2RequestDto,
  UserPropertyEditHasGarbageUtilityIncludedV2RequestDto,
  UserPropertyEditHasGardenOutDoorCommonAreaV2RequestDto,
  UserPropertyEditHasGasHeatingSourceV2RequestDto,
  UserPropertyEditHasGasUtilityIncludedV2RequestDto,
  UserPropertyEditHasGatedEntrySecurityV2RequestDto,
  UserPropertyEditHasGazeboOutDoorCommonAreaV2RequestDto,
  UserPropertyEditHasGolfCourseViewV2RequestDto,
  UserPropertyEditHasGuestSuiteV2RequestDto,
  UserPropertyEditHasHardwoodFloorCoveringV2RequestDto,
  UserPropertyEditHasHeatingUtilityIncludedV2RequestDto,
  UserPropertyEditHasHeatPumpHeatingSourceV2RequestDto,
  UserPropertyEditHasHighSpeedInternetV2RequestDto,
  UserPropertyEditHasHotTubV2RequestDto,
  UserPropertyEditHasHotWaterUtilityIncludedV2RequestDto,
  UserPropertyEditHasIntercomSecurityV2RequestDto,
  UserPropertyEditHasInternetUtilityIncludedV2RequestDto,
  UserPropertyEditHasLaminateFloorCoveringV2RequestDto,
  UserPropertyEditHasLawnOutDoorCommonAreaV2RequestDto,
  UserPropertyEditHasLessThanOneYearLeaseLengthsV2RequestDto,
  UserPropertyEditHasLibraryCommunityRoomV2RequestDto,
  UserPropertyEditHasLinoleumFloorCoveringV2RequestDto,
  UserPropertyEditHasLoungeCommunityRoomV2RequestDto,
  UserPropertyEditHasMicrowaveOvenApplianceV2RequestDto,
  UserPropertyEditHasMonthlyLeaseLengthsV2RequestDto,
  UserPropertyEditHasMoreThanOneYearLeaseLengthsV2RequestDto,
  UserPropertyEditHasMountainViewV2RequestDto,
  UserPropertyEditHasMultiLevelGarageParkingV2RequestDto,
  UserPropertyEditHasMultiPurposeSportCourtV2RequestDto,
  UserPropertyEditHasNightPatrolSecurityV2RequestDto,
  UserPropertyEditHasNoneLeaseLengthsV2RequestDto,
  UserPropertyEditHasNoneParkingV2RequestDto,
  UserPropertyEditHasOilHeatingSourceV2RequestDto,
  UserPropertyEditHasOneYearLeaseLengthsV2RequestDto,
  UserPropertyEditHasOnlineMaintenancePortalV2RequestDto,
  UserPropertyEditHasOnlineRentPaymentV2RequestDto,
  UserPropertyEditHasOnsiteManagementV2RequestDto,
  UserPropertyEditHasOtherSportCourtV2RequestDto,
  UserPropertyEditHasOvenApplianceV2RequestDto,
  UserPropertyEditHasPackageServiceV2RequestDto,
  UserPropertyEditHasParkingLotParkingV2RequestDto,
  UserPropertyEditHasParkViewV2RequestDto,
  UserPropertyEditHasPartyRoomCommunityRoomV2RequestDto,
  UserPropertyEditHasPatioBalconyV2RequestDto,
  UserPropertyEditHasPatioOutDoorCommonAreaV2RequestDto,
  UserPropertyEditHasPetParkV2RequestDto,
  UserPropertyEditHasPetWashingStationCommunityRoomV2RequestDto,
  UserPropertyEditHasPicnicAreaOutDoorCommonAreaV2RequestDto,
  UserPropertyEditHasPlaygroundOutDoorCommonAreaV2RequestDto,
  UserPropertyEditHasPropaneButaneHeatingSourceV2RequestDto,
  UserPropertyEditHasRacquetballSportCourtV2RequestDto,
  UserPropertyEditHasRangeApplianceV2RequestDto,
  UserPropertyEditHasRefrigeratorApplianceV2RequestDto,
  UserPropertyEditHasRooftopDeckOutDoorCommonAreaV2RequestDto,
  UserPropertyEditHasSatelliteTvV2RequestDto,
  UserPropertyEditHasSaunaV2RequestDto,
  UserPropertyEditHasSewageUtilityIncludedV2RequestDto,
  UserPropertyEditHasShuffleboardSportCourtV2RequestDto,
  UserPropertyEditHasSixMonthsLeaseLengthsV2RequestDto,
  UserPropertyEditHasSlateFloorCoveringV2RequestDto,
  UserPropertyEditHasSoftwoodFloorCoveringV2RequestDto,
  UserPropertyEditHasSolarHeatingSourceV2RequestDto,
  UserPropertyEditHasSpanishSpeakingStaffV2RequestDto,
  UserPropertyEditHasSportsFieldSportCourtV2RequestDto,
  UserPropertyEditHasStorageSpaceV2RequestDto,
  UserPropertyEditHasSwimmingPoolV2RequestDto,
  UserPropertyEditHasTennisSportCourtV2RequestDto,
  UserPropertyEditHasTerritorialViewV2RequestDto,
  UserPropertyEditHasTheaterCommunityRoomV2RequestDto,
  UserPropertyEditHasTileFloorCoveringV2RequestDto,
  UserPropertyEditHasTrailOutDoorCommonAreaV2RequestDto,
  UserPropertyEditHasTrashCompactorApplianceV2RequestDto,
  UserPropertyEditHasTwentyFourHourMaintenanceV2RequestDto,
  UserPropertyEditHasUndergroundGarageParkingV2RequestDto,
  UserPropertyEditHasValetTrashV2RequestDto,
  UserPropertyEditHasVinylFloorCoveringV2RequestDto,
  UserPropertyEditHasVolleyballSportCourtV2RequestDto,
  UserPropertyEditHasWallAirConditioningV2RequestDto,
  UserPropertyEditHasWasherDryerHookupsApplianceV2RequestDto,
  UserPropertyEditHasWaterFeatureOutDoorCommonAreaV2RequestDto,
  UserPropertyEditHasWaterUtilityIncludedV2RequestDto,
  UserPropertyEditHasWaterViewV2RequestDto,
  UserPropertyEditHasWindowAirConditioningV2RequestDto,
  UserPropertyEditHasWoodedViewV2RequestDto,
  UserPropertyEditIsFurnishedV2RequestDto,
  UserPropertyEditIsOver55V2RequestDto,
  UserPropertyEditSmokingAllowedV2RequestDto,
} from '../..';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasAirConditioningUtilityIncluded_Path =
  '/api/web/v2/users/properties/amenities/hasAirConditioningUtilityIncluded';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasAirConditioningUtilityIncluded = (
  postData: UserPropertyEditHasAirConditioningUtilityIncludedV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasAirConditioningUtilityIncludedV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasAirConditioningUtilityIncluded_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasAssistedLiving_Path =
  '/api/web/v2/users/properties/amenities/hasAssistedLiving';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasAssistedLiving = (
  postData: UserPropertyEditHasAssistedLivingV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasAssistedLivingV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasAssistedLiving_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasAttachedGarageParking_Path =
  '/api/web/v2/users/properties/amenities/hasAttachedGarageParking';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasAttachedGarageParking = (
  postData: UserPropertyEditHasAttachedGarageParkingV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasAttachedGarageParkingV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasAttachedGarageParking_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasBarbecue_Path =
  '/api/web/v2/users/properties/amenities/hasBarbecue';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasBarbecue = (
  postData: UserPropertyEditHasBarbecueV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasBarbecueV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasBarbecue_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasBasketballSportCourt_Path =
  '/api/web/v2/users/properties/amenities/hasBasketballSportCourt';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasBasketballSportCourt = (
  postData: UserPropertyEditHasBasketballSportCourtV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasBasketballSportCourtV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasBasketballSportCourt_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasBicycleStorage_Path =
  '/api/web/v2/users/properties/amenities/hasBicycleStorage';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasBicycleStorage = (
  postData: UserPropertyEditHasBicycleStorageV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasBicycleStorageV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasBicycleStorage_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasBocceSportCourt_Path =
  '/api/web/v2/users/properties/amenities/hasBocceSportCourt';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasBocceSportCourt = (
  postData: UserPropertyEditHasBocceSportCourtV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasBocceSportCourtV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasBocceSportCourt_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasBuildingWideWireless_Path =
  '/api/web/v2/users/properties/amenities/hasBuildingWideWireless';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasBuildingWideWireless = (
  postData: UserPropertyEditHasBuildingWideWirelessV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasBuildingWideWirelessV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasBuildingWideWireless_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasBusinessCenterCommunityRoom_Path =
  '/api/web/v2/users/properties/amenities/hasBusinessCenterCommunityRoom';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasBusinessCenterCommunityRoom = (
  postData: UserPropertyEditHasBusinessCenterCommunityRoomV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasBusinessCenterCommunityRoomV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasBusinessCenterCommunityRoom_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCableTv_Path =
  '/api/web/v2/users/properties/amenities/hasCableTv';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCableTv = (
  postData: UserPropertyEditHasCableTvV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasCableTvV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCableTv_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCableTvUtilityIncluded_Path =
  '/api/web/v2/users/properties/amenities/hasCableTvUtilityIncluded';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCableTvUtilityIncluded = (
  postData: UserPropertyEditHasCableTvUtilityIncludedV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasCableTvUtilityIncludedV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCableTvUtilityIncluded_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCarpetFloorCovering_Path =
  '/api/web/v2/users/properties/amenities/hasCarpetFloorCovering';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCarpetFloorCovering = (
  postData: UserPropertyEditHasCarpetFloorCoveringV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasCarpetFloorCoveringV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCarpetFloorCovering_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCeilingFan_Path =
  '/api/web/v2/users/properties/amenities/hasCeilingFan';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCeilingFan = (
  postData: UserPropertyEditHasCeilingFanV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasCeilingFanV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCeilingFan_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCentralAirConditioning_Path =
  '/api/web/v2/users/properties/amenities/hasCentralAirConditioning';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCentralAirConditioning = (
  postData: UserPropertyEditHasCentralAirConditioningV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasCentralAirConditioningV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCentralAirConditioning_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCityView_Path =
  '/api/web/v2/users/properties/amenities/hasCityView';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCityView = (
  postData: UserPropertyEditHasCityViewV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasCityViewV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCityView_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasClubHouseCommunityRoom_Path =
  '/api/web/v2/users/properties/amenities/hasClubHouseCommunityRoom';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasClubHouseCommunityRoom = (
  postData: UserPropertyEditHasClubHouseCommunityRoomV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasClubHouseCommunityRoomV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasClubHouseCommunityRoom_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasConcreteFloorCovering_Path =
  '/api/web/v2/users/properties/amenities/hasConcreteFloorCovering';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasConcreteFloorCovering = (
  postData: UserPropertyEditHasConcreteFloorCoveringV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasConcreteFloorCoveringV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasConcreteFloorCovering_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasConferenceRoomCommunityRoom_Path =
  '/api/web/v2/users/properties/amenities/hasConferenceRoomCommunityRoom';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasConferenceRoomCommunityRoom = (
  postData: UserPropertyEditHasConferenceRoomCommunityRoomV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasConferenceRoomCommunityRoomV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasConferenceRoomCommunityRoom_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasControlledAccessSecurity_Path =
  '/api/web/v2/users/properties/amenities/hasControlledAccessSecurity';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasControlledAccessSecurity = (
  postData: UserPropertyEditHasControlledAccessSecurityV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasControlledAccessSecurityV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasControlledAccessSecurity_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasConvectionOvenAppliance_Path =
  '/api/web/v2/users/properties/amenities/hasConvectionOvenAppliance';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasConvectionOvenAppliance = (
  postData: UserPropertyEditHasConvectionOvenApplianceV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasConvectionOvenApplianceV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasConvectionOvenAppliance_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCoveredParkingParking_Path =
  '/api/web/v2/users/properties/amenities/hasCoveredParkingParking';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCoveredParkingParking = (
  postData: UserPropertyEditHasCoveredParkingParkingV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasCoveredParkingParkingV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCoveredParkingParking_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDeckOutDoorCommonArea_Path =
  '/api/web/v2/users/properties/amenities/hasDeckOutDoorCommonArea';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDeckOutDoorCommonArea = (
  postData: UserPropertyEditHasDeckOutDoorCommonAreaV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasDeckOutDoorCommonAreaV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDeckOutDoorCommonArea_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDetachedGarageParking_Path =
  '/api/web/v2/users/properties/amenities/hasDetachedGarageParking';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDetachedGarageParking = (
  postData: UserPropertyEditHasDetachedGarageParkingV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasDetachedGarageParkingV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDetachedGarageParking_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDisabledAccess_Path =
  '/api/web/v2/users/properties/amenities/hasDisabledAccess';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDisabledAccess = (
  postData: UserPropertyEditHasDisabledAccessV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasDisabledAccessV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDisabledAccess_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDishwasherAppliance_Path =
  '/api/web/v2/users/properties/amenities/hasDishwasherAppliance';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDishwasherAppliance = (
  postData: UserPropertyEditHasDishwasherApplianceV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasDishwasherApplianceV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDishwasherAppliance_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDoormanSecurity_Path =
  '/api/web/v2/users/properties/amenities/hasDoormanSecurity';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDoormanSecurity = (
  postData: UserPropertyEditHasDoormanSecurityV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasDoormanSecurityV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDoormanSecurity_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDoubleOvenAppliance_Path =
  '/api/web/v2/users/properties/amenities/hasDoubleOvenAppliance';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDoubleOvenAppliance = (
  postData: UserPropertyEditHasDoubleOvenApplianceV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasDoubleOvenApplianceV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDoubleOvenAppliance_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDryCleaningDropOff_Path =
  '/api/web/v2/users/properties/amenities/hasDryCleaningDropOff';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDryCleaningDropOff = (
  postData: UserPropertyEditHasDryCleaningDropOffV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasDryCleaningDropOffV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDryCleaningDropOff_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasElectricHeatingSource_Path =
  '/api/web/v2/users/properties/amenities/hasElectricHeatingSource';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasElectricHeatingSource = (
  postData: UserPropertyEditHasElectricHeatingSourceV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasElectricHeatingSourceV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasElectricHeatingSource_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasElectricityUtilityIncluded_Path =
  '/api/web/v2/users/properties/amenities/hasElectricityUtilityIncluded';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasElectricityUtilityIncluded = (
  postData: UserPropertyEditHasElectricityUtilityIncludedV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasElectricityUtilityIncludedV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasElectricityUtilityIncluded_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasElevator_Path =
  '/api/web/v2/users/properties/amenities/hasElevator';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasElevator = (
  postData: UserPropertyEditHasElevatorV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasElevatorV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasElevator_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasFireplace_Path =
  '/api/web/v2/users/properties/amenities/hasFireplace';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasFireplace = (
  postData: UserPropertyEditHasFireplaceV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasFireplaceV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasFireplace_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasFitnessCenterCommunityRoom_Path =
  '/api/web/v2/users/properties/amenities/hasFitnessCenterCommunityRoom';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasFitnessCenterCommunityRoom = (
  postData: UserPropertyEditHasFitnessCenterCommunityRoomV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasFitnessCenterCommunityRoomV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasFitnessCenterCommunityRoom_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasFlexibleLeaseLengths_Path =
  '/api/web/v2/users/properties/amenities/hasFlexibleLeaseLengths';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasFlexibleLeaseLengths = (
  postData: UserPropertyEditHasFlexibleLeaseLengthsV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasFlexibleLeaseLengthsV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasFlexibleLeaseLengths_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasFreezerAppliance_Path =
  '/api/web/v2/users/properties/amenities/hasFreezerAppliance';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasFreezerAppliance = (
  postData: UserPropertyEditHasFreezerApplianceV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasFreezerApplianceV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasFreezerAppliance_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGameRoomCommunityRoom_Path =
  '/api/web/v2/users/properties/amenities/hasGameRoomCommunityRoom';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGameRoomCommunityRoom = (
  postData: UserPropertyEditHasGameRoomCommunityRoomV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasGameRoomCommunityRoomV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGameRoomCommunityRoom_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGarbageDisposalAppliance_Path =
  '/api/web/v2/users/properties/amenities/hasGarbageDisposalAppliance';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGarbageDisposalAppliance = (
  postData: UserPropertyEditHasGarbageDisposalApplianceV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasGarbageDisposalApplianceV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGarbageDisposalAppliance_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGarbageUtilityIncluded_Path =
  '/api/web/v2/users/properties/amenities/hasGarbageUtilityIncluded';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGarbageUtilityIncluded = (
  postData: UserPropertyEditHasGarbageUtilityIncludedV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasGarbageUtilityIncludedV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGarbageUtilityIncluded_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGardenOutDoorCommonArea_Path =
  '/api/web/v2/users/properties/amenities/hasGardenOutDoorCommonArea';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGardenOutDoorCommonArea = (
  postData: UserPropertyEditHasGardenOutDoorCommonAreaV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasGardenOutDoorCommonAreaV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGardenOutDoorCommonArea_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGasHeatingSource_Path =
  '/api/web/v2/users/properties/amenities/hasGasHeatingSource';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGasHeatingSource = (
  postData: UserPropertyEditHasGasHeatingSourceV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasGasHeatingSourceV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGasHeatingSource_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGasUtilityIncluded_Path =
  '/api/web/v2/users/properties/amenities/hasGasUtilityIncluded';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGasUtilityIncluded = (
  postData: UserPropertyEditHasGasUtilityIncludedV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasGasUtilityIncludedV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGasUtilityIncluded_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGatedEntrySecurity_Path =
  '/api/web/v2/users/properties/amenities/hasGatedEntrySecurity';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGatedEntrySecurity = (
  postData: UserPropertyEditHasGatedEntrySecurityV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasGatedEntrySecurityV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGatedEntrySecurity_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGazeboOutDoorCommonArea_Path =
  '/api/web/v2/users/properties/amenities/hasGazeboOutDoorCommonArea';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGazeboOutDoorCommonArea = (
  postData: UserPropertyEditHasGazeboOutDoorCommonAreaV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasGazeboOutDoorCommonAreaV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGazeboOutDoorCommonArea_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGolfCourseView_Path =
  '/api/web/v2/users/properties/amenities/hasGolfCourseView';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGolfCourseView = (
  postData: UserPropertyEditHasGolfCourseViewV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasGolfCourseViewV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGolfCourseView_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGuestSuite_Path =
  '/api/web/v2/users/properties/amenities/hasGuestSuite';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGuestSuite = (
  postData: UserPropertyEditHasGuestSuiteV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasGuestSuiteV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGuestSuite_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasHardwoodFloorCovering_Path =
  '/api/web/v2/users/properties/amenities/hasHardwoodFloorCovering';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasHardwoodFloorCovering = (
  postData: UserPropertyEditHasHardwoodFloorCoveringV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasHardwoodFloorCoveringV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasHardwoodFloorCovering_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasHeatingUtilityIncluded_Path =
  '/api/web/v2/users/properties/amenities/hasHeatingUtilityIncluded';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasHeatingUtilityIncluded = (
  postData: UserPropertyEditHasHeatingUtilityIncludedV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasHeatingUtilityIncludedV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasHeatingUtilityIncluded_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasHeatPumpHeatingSource_Path =
  '/api/web/v2/users/properties/amenities/hasHeatPumpHeatingSource';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasHeatPumpHeatingSource = (
  postData: UserPropertyEditHasHeatPumpHeatingSourceV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasHeatPumpHeatingSourceV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasHeatPumpHeatingSource_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasHighSpeedInternet_Path =
  '/api/web/v2/users/properties/amenities/hasHighSpeedInternet';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasHighSpeedInternet = (
  postData: UserPropertyEditHasHighSpeedInternetV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasHighSpeedInternetV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasHighSpeedInternet_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasHotTub_Path =
  '/api/web/v2/users/properties/amenities/hasHotTub';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasHotTub = (
  postData: UserPropertyEditHasHotTubV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasHotTubV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasHotTub_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasHotWaterUtilityIncluded_Path =
  '/api/web/v2/users/properties/amenities/hasHotWaterUtilityIncluded';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasHotWaterUtilityIncluded = (
  postData: UserPropertyEditHasHotWaterUtilityIncludedV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasHotWaterUtilityIncludedV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasHotWaterUtilityIncluded_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasIntercomSecurity_Path =
  '/api/web/v2/users/properties/amenities/hasIntercomSecurity';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasIntercomSecurity = (
  postData: UserPropertyEditHasIntercomSecurityV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasIntercomSecurityV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasIntercomSecurity_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasInternetUtilityIncluded_Path =
  '/api/web/v2/users/properties/amenities/hasInternetUtilityIncluded';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasInternetUtilityIncluded = (
  postData: UserPropertyEditHasInternetUtilityIncludedV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasInternetUtilityIncludedV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasInternetUtilityIncluded_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasLaminateFloorCovering_Path =
  '/api/web/v2/users/properties/amenities/hasLaminateFloorCovering';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasLaminateFloorCovering = (
  postData: UserPropertyEditHasLaminateFloorCoveringV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasLaminateFloorCoveringV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasLaminateFloorCovering_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasLawnOutDoorCommonArea_Path =
  '/api/web/v2/users/properties/amenities/hasLawnOutDoorCommonArea';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasLawnOutDoorCommonArea = (
  postData: UserPropertyEditHasLawnOutDoorCommonAreaV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasLawnOutDoorCommonAreaV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasLawnOutDoorCommonArea_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasLessThanOneYearLeaseLengths_Path =
  '/api/web/v2/users/properties/amenities/hasLessThanOneYearLeaseLengths';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasLessThanOneYearLeaseLengths = (
  postData: UserPropertyEditHasLessThanOneYearLeaseLengthsV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasLessThanOneYearLeaseLengthsV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasLessThanOneYearLeaseLengths_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasLibraryCommunityRoom_Path =
  '/api/web/v2/users/properties/amenities/hasLibraryCommunityRoom';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasLibraryCommunityRoom = (
  postData: UserPropertyEditHasLibraryCommunityRoomV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasLibraryCommunityRoomV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasLibraryCommunityRoom_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasLinoleumFloorCovering_Path =
  '/api/web/v2/users/properties/amenities/hasLinoleumFloorCovering';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasLinoleumFloorCovering = (
  postData: UserPropertyEditHasLinoleumFloorCoveringV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasLinoleumFloorCoveringV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasLinoleumFloorCovering_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasLoungeCommunityRoom_Path =
  '/api/web/v2/users/properties/amenities/hasLoungeCommunityRoom';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasLoungeCommunityRoom = (
  postData: UserPropertyEditHasLoungeCommunityRoomV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasLoungeCommunityRoomV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasLoungeCommunityRoom_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasMicrowaveOvenAppliance_Path =
  '/api/web/v2/users/properties/amenities/hasMicrowaveOvenAppliance';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasMicrowaveOvenAppliance = (
  postData: UserPropertyEditHasMicrowaveOvenApplianceV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasMicrowaveOvenApplianceV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasMicrowaveOvenAppliance_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasMonthlyLeaseLengths_Path =
  '/api/web/v2/users/properties/amenities/hasMonthlyLeaseLengths';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasMonthlyLeaseLengths = (
  postData: UserPropertyEditHasMonthlyLeaseLengthsV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasMonthlyLeaseLengthsV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasMonthlyLeaseLengths_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasMoreThanOneYearLeaseLengths_Path =
  '/api/web/v2/users/properties/amenities/hasMoreThanOneYearLeaseLengths';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasMoreThanOneYearLeaseLengths = (
  postData: UserPropertyEditHasMoreThanOneYearLeaseLengthsV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasMoreThanOneYearLeaseLengthsV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasMoreThanOneYearLeaseLengths_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasMountainView_Path =
  '/api/web/v2/users/properties/amenities/hasMountainView';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasMountainView = (
  postData: UserPropertyEditHasMountainViewV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasMountainViewV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasMountainView_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasMultiLevelGarageParking_Path =
  '/api/web/v2/users/properties/amenities/hasMultiLevelGarageParking';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasMultiLevelGarageParking = (
  postData: UserPropertyEditHasMultiLevelGarageParkingV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasMultiLevelGarageParkingV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasMultiLevelGarageParking_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasMultiPurposeSportCourt_Path =
  '/api/web/v2/users/properties/amenities/hasMultiPurposeSportCourt';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasMultiPurposeSportCourt = (
  postData: UserPropertyEditHasMultiPurposeSportCourtV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasMultiPurposeSportCourtV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasMultiPurposeSportCourt_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasNightPatrolSecurity_Path =
  '/api/web/v2/users/properties/amenities/hasNightPatrolSecurity';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasNightPatrolSecurity = (
  postData: UserPropertyEditHasNightPatrolSecurityV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasNightPatrolSecurityV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasNightPatrolSecurity_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasNoneLeaseLengths_Path =
  '/api/web/v2/users/properties/amenities/hasNoneLeaseLengths';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasNoneLeaseLengths = (
  postData: UserPropertyEditHasNoneLeaseLengthsV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasNoneLeaseLengthsV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasNoneLeaseLengths_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasNoneParking_Path =
  '/api/web/v2/users/properties/amenities/hasNoneParking';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasNoneParking = (
  postData: UserPropertyEditHasNoneParkingV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasNoneParkingV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasNoneParking_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOilHeatingSource_Path =
  '/api/web/v2/users/properties/amenities/hasOilHeatingSource';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOilHeatingSource = (
  postData: UserPropertyEditHasOilHeatingSourceV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasOilHeatingSourceV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOilHeatingSource_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOneYearLeaseLengths_Path =
  '/api/web/v2/users/properties/amenities/hasOneYearLeaseLengths';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOneYearLeaseLengths = (
  postData: UserPropertyEditHasOneYearLeaseLengthsV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasOneYearLeaseLengthsV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOneYearLeaseLengths_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOnlineMaintenancePortal_Path =
  '/api/web/v2/users/properties/amenities/hasOnlineMaintenancePortal';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOnlineMaintenancePortal = (
  postData: UserPropertyEditHasOnlineMaintenancePortalV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasOnlineMaintenancePortalV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOnlineMaintenancePortal_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOnlineRentPayment_Path =
  '/api/web/v2/users/properties/amenities/hasOnlineRentPayment';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOnlineRentPayment = (
  postData: UserPropertyEditHasOnlineRentPaymentV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasOnlineRentPaymentV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOnlineRentPayment_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOnsiteManagement_Path =
  '/api/web/v2/users/properties/amenities/hasOnsiteManagement';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOnsiteManagement = (
  postData: UserPropertyEditHasOnsiteManagementV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasOnsiteManagementV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOnsiteManagement_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOtherSportCourt_Path =
  '/api/web/v2/users/properties/amenities/hasOtherSportCourt';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOtherSportCourt = (
  postData: UserPropertyEditHasOtherSportCourtV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasOtherSportCourtV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOtherSportCourt_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOvenAppliance_Path =
  '/api/web/v2/users/properties/amenities/hasOvenAppliance';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOvenAppliance = (
  postData: UserPropertyEditHasOvenApplianceV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasOvenApplianceV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOvenAppliance_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPackageService_Path =
  '/api/web/v2/users/properties/amenities/hasPackageService';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPackageService = (
  postData: UserPropertyEditHasPackageServiceV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasPackageServiceV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPackageService_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasParkingLotParking_Path =
  '/api/web/v2/users/properties/amenities/hasParkingLotParking';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasParkingLotParking = (
  postData: UserPropertyEditHasParkingLotParkingV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasParkingLotParkingV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasParkingLotParking_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasParkView_Path =
  '/api/web/v2/users/properties/amenities/hasParkView';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasParkView = (
  postData: UserPropertyEditHasParkViewV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasParkViewV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasParkView_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPartyRoomCommunityRoom_Path =
  '/api/web/v2/users/properties/amenities/hasPartyRoomCommunityRoom';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPartyRoomCommunityRoom = (
  postData: UserPropertyEditHasPartyRoomCommunityRoomV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasPartyRoomCommunityRoomV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPartyRoomCommunityRoom_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPatioBalcony_Path =
  '/api/web/v2/users/properties/amenities/hasPatioBalcony';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPatioBalcony = (
  postData: UserPropertyEditHasPatioBalconyV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasPatioBalconyV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPatioBalcony_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPatioOutDoorCommonArea_Path =
  '/api/web/v2/users/properties/amenities/hasPatioOutDoorCommonArea';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPatioOutDoorCommonArea = (
  postData: UserPropertyEditHasPatioOutDoorCommonAreaV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasPatioOutDoorCommonAreaV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPatioOutDoorCommonArea_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPetPark_Path =
  '/api/web/v2/users/properties/amenities/hasPetPark';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPetPark = (
  postData: UserPropertyEditHasPetParkV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasPetParkV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPetPark_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPetWashingStationCommunityRoom_Path =
  '/api/web/v2/users/properties/amenities/hasPetWashingStationCommunityRoom';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPetWashingStationCommunityRoom = (
  postData: UserPropertyEditHasPetWashingStationCommunityRoomV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasPetWashingStationCommunityRoomV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPetWashingStationCommunityRoom_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPicnicAreaOutDoorCommonArea_Path =
  '/api/web/v2/users/properties/amenities/hasPicnicAreaOutDoorCommonArea';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPicnicAreaOutDoorCommonArea = (
  postData: UserPropertyEditHasPicnicAreaOutDoorCommonAreaV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasPicnicAreaOutDoorCommonAreaV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPicnicAreaOutDoorCommonArea_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPlaygroundOutDoorCommonArea_Path =
  '/api/web/v2/users/properties/amenities/hasPlaygroundOutDoorCommonArea';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPlaygroundOutDoorCommonArea = (
  postData: UserPropertyEditHasPlaygroundOutDoorCommonAreaV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasPlaygroundOutDoorCommonAreaV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPlaygroundOutDoorCommonArea_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPropaneButaneHeatingSource_Path =
  '/api/web/v2/users/properties/amenities/hasPropaneButaneHeatingSource';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPropaneButaneHeatingSource = (
  postData: UserPropertyEditHasPropaneButaneHeatingSourceV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasPropaneButaneHeatingSourceV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPropaneButaneHeatingSource_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasRacquetballSportCourt_Path =
  '/api/web/v2/users/properties/amenities/hasRacquetballSportCourt';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasRacquetballSportCourt = (
  postData: UserPropertyEditHasRacquetballSportCourtV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasRacquetballSportCourtV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasRacquetballSportCourt_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasRangeAppliance_Path =
  '/api/web/v2/users/properties/amenities/hasRangeAppliance';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasRangeAppliance = (
  postData: UserPropertyEditHasRangeApplianceV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasRangeApplianceV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasRangeAppliance_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasRefrigeratorAppliance_Path =
  '/api/web/v2/users/properties/amenities/hasRefrigeratorAppliance';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasRefrigeratorAppliance = (
  postData: UserPropertyEditHasRefrigeratorApplianceV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasRefrigeratorApplianceV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasRefrigeratorAppliance_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasRooftopDeckOutDoorCommonArea_Path =
  '/api/web/v2/users/properties/amenities/hasRooftopDeckOutDoorCommonArea';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasRooftopDeckOutDoorCommonArea = (
  postData: UserPropertyEditHasRooftopDeckOutDoorCommonAreaV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasRooftopDeckOutDoorCommonAreaV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasRooftopDeckOutDoorCommonArea_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSatelliteTv_Path =
  '/api/web/v2/users/properties/amenities/hasSatelliteTv';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSatelliteTv = (
  postData: UserPropertyEditHasSatelliteTvV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasSatelliteTvV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSatelliteTv_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSauna_Path =
  '/api/web/v2/users/properties/amenities/hasSauna';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSauna = (
  postData: UserPropertyEditHasSaunaV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasSaunaV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSauna_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSewageUtilityIncluded_Path =
  '/api/web/v2/users/properties/amenities/hasSewageUtilityIncluded';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSewageUtilityIncluded = (
  postData: UserPropertyEditHasSewageUtilityIncludedV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasSewageUtilityIncludedV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSewageUtilityIncluded_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasShuffleboardSportCourt_Path =
  '/api/web/v2/users/properties/amenities/hasShuffleboardSportCourt';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasShuffleboardSportCourt = (
  postData: UserPropertyEditHasShuffleboardSportCourtV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasShuffleboardSportCourtV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasShuffleboardSportCourt_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSixMonthsLeaseLengths_Path =
  '/api/web/v2/users/properties/amenities/hasSixMonthsLeaseLengths';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSixMonthsLeaseLengths = (
  postData: UserPropertyEditHasSixMonthsLeaseLengthsV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasSixMonthsLeaseLengthsV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSixMonthsLeaseLengths_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSlateFloorCovering_Path =
  '/api/web/v2/users/properties/amenities/hasSlateFloorCovering';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSlateFloorCovering = (
  postData: UserPropertyEditHasSlateFloorCoveringV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasSlateFloorCoveringV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSlateFloorCovering_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSoftwoodFloorCovering_Path =
  '/api/web/v2/users/properties/amenities/hasSoftwoodFloorCovering';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSoftwoodFloorCovering = (
  postData: UserPropertyEditHasSoftwoodFloorCoveringV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasSoftwoodFloorCoveringV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSoftwoodFloorCovering_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSolarHeatingSource_Path =
  '/api/web/v2/users/properties/amenities/hasSolarHeatingSource';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSolarHeatingSource = (
  postData: UserPropertyEditHasSolarHeatingSourceV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasSolarHeatingSourceV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSolarHeatingSource_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSpanishSpeakingStaff_Path =
  '/api/web/v2/users/properties/amenities/hasSpanishSpeakingStaff';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSpanishSpeakingStaff = (
  postData: UserPropertyEditHasSpanishSpeakingStaffV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasSpanishSpeakingStaffV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSpanishSpeakingStaff_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSportsFieldSportCourt_Path =
  '/api/web/v2/users/properties/amenities/hasSportsFieldSportCourt';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSportsFieldSportCourt = (
  postData: UserPropertyEditHasSportsFieldSportCourtV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasSportsFieldSportCourtV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSportsFieldSportCourt_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasStorageSpace_Path =
  '/api/web/v2/users/properties/amenities/hasStorageSpace';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasStorageSpace = (
  postData: UserPropertyEditHasStorageSpaceV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasStorageSpaceV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasStorageSpace_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSwimmingPool_Path =
  '/api/web/v2/users/properties/amenities/hasSwimmingPool';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSwimmingPool = (
  postData: UserPropertyEditHasSwimmingPoolV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasSwimmingPoolV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSwimmingPool_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTennisSportCourt_Path =
  '/api/web/v2/users/properties/amenities/hasTennisSportCourt';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTennisSportCourt = (
  postData: UserPropertyEditHasTennisSportCourtV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasTennisSportCourtV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTennisSportCourt_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTerritorialView_Path =
  '/api/web/v2/users/properties/amenities/hasTerritorialView';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTerritorialView = (
  postData: UserPropertyEditHasTerritorialViewV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasTerritorialViewV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTerritorialView_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTheaterCommunityRoom_Path =
  '/api/web/v2/users/properties/amenities/hasTheaterCommunityRoom';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTheaterCommunityRoom = (
  postData: UserPropertyEditHasTheaterCommunityRoomV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasTheaterCommunityRoomV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTheaterCommunityRoom_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTileFloorCovering_Path =
  '/api/web/v2/users/properties/amenities/hasTileFloorCovering';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTileFloorCovering = (
  postData: UserPropertyEditHasTileFloorCoveringV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasTileFloorCoveringV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTileFloorCovering_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTrailOutDoorCommonArea_Path =
  '/api/web/v2/users/properties/amenities/hasTrailOutDoorCommonArea';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTrailOutDoorCommonArea = (
  postData: UserPropertyEditHasTrailOutDoorCommonAreaV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasTrailOutDoorCommonAreaV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTrailOutDoorCommonArea_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTrashCompactorAppliance_Path =
  '/api/web/v2/users/properties/amenities/hasTrashCompactorAppliance';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTrashCompactorAppliance = (
  postData: UserPropertyEditHasTrashCompactorApplianceV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasTrashCompactorApplianceV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTrashCompactorAppliance_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTwentyFourHourMaintenance_Path =
  '/api/web/v2/users/properties/amenities/hasTwentyFourHourMaintenance';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTwentyFourHourMaintenance = (
  postData: UserPropertyEditHasTwentyFourHourMaintenanceV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasTwentyFourHourMaintenanceV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTwentyFourHourMaintenance_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasUndergroundGarageParking_Path =
  '/api/web/v2/users/properties/amenities/hasUndergroundGarageParking';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasUndergroundGarageParking = (
  postData: UserPropertyEditHasUndergroundGarageParkingV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasUndergroundGarageParkingV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasUndergroundGarageParking_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasValetTrash_Path =
  '/api/web/v2/users/properties/amenities/hasValetTrash';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasValetTrash = (
  postData: UserPropertyEditHasValetTrashV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasValetTrashV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasValetTrash_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasVinylFloorCovering_Path =
  '/api/web/v2/users/properties/amenities/hasVinylFloorCovering';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasVinylFloorCovering = (
  postData: UserPropertyEditHasVinylFloorCoveringV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasVinylFloorCoveringV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasVinylFloorCovering_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasVolleyballSportCourt_Path =
  '/api/web/v2/users/properties/amenities/hasVolleyballSportCourt';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasVolleyballSportCourt = (
  postData: UserPropertyEditHasVolleyballSportCourtV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasVolleyballSportCourtV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasVolleyballSportCourt_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWallAirConditioning_Path =
  '/api/web/v2/users/properties/amenities/hasWallAirConditioning';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWallAirConditioning = (
  postData: UserPropertyEditHasWallAirConditioningV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasWallAirConditioningV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWallAirConditioning_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWasherDryerHookupsAppliance_Path =
  '/api/web/v2/users/properties/amenities/hasWasherDryerHookupsAppliance';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWasherDryerHookupsAppliance = (
  postData: UserPropertyEditHasWasherDryerHookupsApplianceV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasWasherDryerHookupsApplianceV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWasherDryerHookupsAppliance_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWaterFeatureOutDoorCommonArea_Path =
  '/api/web/v2/users/properties/amenities/hasWaterFeatureOutDoorCommonArea';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWaterFeatureOutDoorCommonArea = (
  postData: UserPropertyEditHasWaterFeatureOutDoorCommonAreaV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasWaterFeatureOutDoorCommonAreaV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWaterFeatureOutDoorCommonArea_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWaterUtilityIncluded_Path =
  '/api/web/v2/users/properties/amenities/hasWaterUtilityIncluded';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWaterUtilityIncluded = (
  postData: UserPropertyEditHasWaterUtilityIncludedV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasWaterUtilityIncludedV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWaterUtilityIncluded_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWaterView_Path =
  '/api/web/v2/users/properties/amenities/hasWaterView';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWaterView = (
  postData: UserPropertyEditHasWaterViewV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasWaterViewV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWaterView_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWindowAirConditioning_Path =
  '/api/web/v2/users/properties/amenities/hasWindowAirConditioning';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWindowAirConditioning = (
  postData: UserPropertyEditHasWindowAirConditioningV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasWindowAirConditioningV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWindowAirConditioning_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWoodedView_Path =
  '/api/web/v2/users/properties/amenities/hasWoodedView';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWoodedView = (
  postData: UserPropertyEditHasWoodedViewV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHasWoodedViewV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWoodedView_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_isFurnished_Path =
  '/api/web/v2/users/properties/amenities/isFurnished';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_isFurnished = (
  postData: UserPropertyEditIsFurnishedV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditIsFurnishedV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_isFurnished_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_isOver55_Path =
  '/api/web/v2/users/properties/amenities/isOver55';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_isOver55 = (
  postData: UserPropertyEditIsOver55V2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditIsOver55V2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_isOver55_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_smokingAllowed_Path =
  '/api/web/v2/users/properties/amenities/smokingAllowed';

export const RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_smokingAllowed = (
  postData: UserPropertyEditSmokingAllowedV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditSmokingAllowedV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_smokingAllowed_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
